import {colors} from "../../theme/theme";
import {Button} from "../button/button";
import {store} from '../../app';
import React from 'react';


import {deviceActions} from '../../store/store';
import {connect} from 'react-redux';

import './alert.scss'
import {translate} from "../../lib/intl";

export function setAlertDialog(alertTitle, alertMessage, alertButtons) {
  store.dispatch(deviceActions.showAlert(alertTitle, alertMessage, alertButtons));
}

export function hideAlertDialog() {
  store.dispatch(deviceActions.clearAlert());
}

class AlertDialog extends React.Component {

  render({alertTitle, alertMessage, alertShown, alertButtons} = this.props) {

    //TODO: fade in alert

    return (
      <div>

        {alertShown && (
          <div className='alertContainer'>
            <div className='alertModal'>
              {alertTitle && (
                <p className="bold center spacing">
                  {alertTitle}
                </p>
              )}

              <p className="center spacing">
                {alertMessage}
              </p>

              {(alertButtons && alertButtons.length > 0)
                ?
                <div className='buttonContainer'>
                  {alertButtons.map((button, index) => (
                    <Button
                      title={button.title}
                      backgroundColor={button.backgroundColor}
                      onPress={() => this._close(button.onPress)}
                    />
                  ))}
                </div>
                :
                <div className='buttonContainer'>
                  <Button
                    title={translate('general.ok')}
                    backgroundColor={colors.brand.darkgray}
                    onPress={() => this._close()}
                  />
                </div>
              }
            </div>
          </div>
        )}

      </div>
    )
  }

  _close(onPressFunction) {
    if (onPressFunction) {
      onPressFunction();
    }
    this.props.clearAlert()
  }
}

const mapStateToProps = (state) => {
  return {
    alertShown: state.device.alertShown,
    alertTitle: state.device.alertTitle,
    alertMessage: state.device.alertMessage,
    alertButtons: state.device.alertButtons
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearAlert: () => dispatch(deviceActions.clearAlert()),
  }
};

const connectedContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertDialog);

export {connectedContainer as AlertDialog};
